// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__yevq_","main":"index_main__5FBcs","collapseContent":"index_collapseContent__tSzH_"};